import React, { Fragment } from 'react';

import arrowDownIcon from '@/static/images/arrowdown.svg';

import { InternalOrExternalPage } from '@/components/Headers/MainHeader/Atoms/InternalOrExternalPage';
import { IPagesWithCategories } from '@/interfaces/page';
import { addOrRemoveClass } from '@/shared/helpers';

interface Props {
  pathLang: string;
  pages: IPagesWithCategories[];
}

const PageList = (props: Props) => {
  const { pathLang, pages } = props;

  return (
    <>
      {pages.map((page, index) => {
        return page.isCategory ? (
          <Fragment key={index}>
            {page.products.length > 0 ? (
              <li className="anim-drop-down-item dynamic-list-item nav-item">
                <div
                  role="button"
                  onClick={() =>
                    addOrRemoveClass(
                      'active',
                      `#responsive-navbar-category-${index}`
                    )
                  }
                  className="anim-drop-down-item nav-item-content"
                >
                  <p>{page.menu || page.name}</p>
                  <img src={arrowDownIcon} alt="arrow-down icon" />
                </div>
                <ul
                  id={`responsive-navbar-category-${index}`}
                  className="anim-drop-down nav-item-subcontent"
                >
                  {page.products.map(({ id, name, currentPath }) => (
                    <li className="anim-drop-down-item" key={id}>
                      <a href={currentPath}>{name}</a>
                    </li>
                  ))}
                </ul>
              </li>
            ) : null}
          </Fragment>
        ) : (
          <li
            className="anim-drop-down-item dynamic-list-item nav-item"
            key={index}
          >
            <InternalOrExternalPage page={page} pathLang={pathLang} />
          </li>
        );
      })}
    </>
  );
};

export default PageList;
